import React, { useEffect, useState, useCallback, useMemo } from "react";
import { Link } from "react-router-dom";
import {  toast } from 'react-toastify';
// Import Images
import multiUser from '../../assets/images/users/multi-user.jpg';

import {
  Col,
  Container,
  Row,
  Card,
  CardHeader,
  CardBody,
  ModalBody,
  Label,
  Input,
  Modal,
  ModalHeader,
  CustomInput,
  Form,
  ModalFooter,
  Button,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormFeedback
} from "reactstrap";
import TableContainer from "../../Components/Common/TableContainer";  
import BreadCrumb from "../../Components/Common/BreadCrumb";
import DeleteModal from "../../Components/Common/DeleteModal";
import { isEmpty } from "lodash"; 
//Import actions 
import { getUserList, addUser, updateUser, deleteUser,baseURL } from '../../utils/usermanagement'; 

// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
 
// Export Modal
import ExportCSVModal from "../../Components/Common/ExportCSVModal"; 
import { nfcAdd,userNfcUpdate } from "../../utils/nfc";

const Users = () => {    
  const [isEdit, setIsEdit] = useState(false);
  const [isInfo, setIsInfo] = useState(false);
  const [user, setUser] = useState([]); 
  
  //delete user
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);  
  
  const [modal, setModal] = useState(false); 
  const [userList, setUserList] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [nfcId, setNfcId] = useState("");
 
  const toggle_modal = useCallback(() => {
      if (modal) {
        setNfcId(null);
        setModal(false);
        loadUserList(currentPage, pageSize);
      } else {
        setModal(true);
      }
    }, [modal]);      
  // Add pagination handler
  const handlePageChange = async (params) => {
     
    try {
      // Add null check and proper parameter names
      const page = params?.pageIndex || 1;
      const pageSize = params?.pageSize || 10;
      
      console.log('=== Users handlePageChange Debug ===');
      console.log('Full params object:', params);
      console.log('params keys:', Object.keys(params || {}));
      console.log('params values:', Object.values(params || {}));
      console.log('params.searchTerm:', params?.searchTerm);
      console.log('params.search:', params?.search);
      console.log('params.query:', params?.query);
      console.log('params.filter:', params?.filter);
      console.log('params.globalFilter:', params?.globalFilter);
      
      const searchTerm = params?.searchTerm || params?.search || params?.query || params?.globalFilter || '';
      
      console.log('Extracted search term:', searchTerm);
      
      // Pass search term to getUserList API
      if (searchTerm && searchTerm.trim()) {
        console.log('Search term found, passing to API:', searchTerm.trim());
      } else {
        console.log('No search term found');
      }
      
      console.log('=== End Users Debug ===');
      
      const response = await getUserList(page, pageSize, searchTerm);
      if(response.status === 200) {
        setTotal(response.data.data.total);
        setUserList(response.data.data.users);   
        setCurrentPage(page);
        setPageSize(pageSize);
      }
    } catch (error) {
       
      toast.error(error.message);
    }
  };
   
  
  const loadUserList = async (page = currentPage, size = pageSize, searchTerm = null) => {
    try { 
       
      const response = await getUserList(page, size, searchTerm);   
      if(response.status === 200){ 
        setTotal(response.data.data.total);
        setUserList(response.data.data.users);  
      }
    } catch (error) {
       
      toast.error(error.message); 
    }
  };

  useEffect(() => { 
    loadUserList(currentPage, pageSize); 
  }, [currentPage, pageSize]); 
  
  useEffect(() => {
    setUser(userList);
  }, [userList]);

  useEffect(() => {
    if (!isEmpty(userList)) {
      setUser(userList);
      setIsEdit(false);
    }
  }, [userList]);


  // Delete Data
  const handleDeleteuser = async () => {
    if (user && user._id) {
     try {
       const response = await deleteUser(user._id);
       if(response.status === 200){ 
        toast.success("User Delete Successfully");  
         loadUserList(currentPage, pageSize);
       } else {
         
        toast.error(response.message); 
       }
     } catch (error) {
       
      toast.error(error.message); 
     }  
      setDeleteModal(false);
    }
  };
  function handleNFCIDChange(value) { 
    setNfcId(value);
}

  const onClickDelete = (user) => {
    setUser(user);
    setDeleteModal(true);
  };
 
  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      first_name: (user && user.first_name) || '',
      last_name: (user && user.last_name) || '',
      email: (user && user.email) || '',
      seedpower_points: (user && user.seedpower_points) || '', 
      phone: (user && user.phone) || '',  
      country: (user && user.country) || '',
      state: (user && user.state) || '',
      city: (user && user.city) || '',
      street_address: (user && user.street_address) || '',
      active: (user && user.active) || true,
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required("Please Enter user Name"),
      last_name: Yup.string().required("Please Enter last_name name"), 
      seedpower_points: Yup.string().required("Please Enter Rating"), 
      phone: Yup.string().required("Please Enter Phone"), 
      email: Yup.string().required("Please Enter Contact Email"),
      country: Yup.string().required("Country is required"),
      state: Yup.string().required("State/Province is required"),
      city: Yup.string().required("City is required"),
      street_address: Yup.string().required("street_address address is required")
    }),
  });

  const handleSubmit = async (values) => {
    if (isEdit) {
      const updateuser = {
        id: user ? user.id : 0,
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        phone: values.phone, 
        street_address: values.street_address,
        seedpower_points: values.seedpower_points, 
        active: values.active, 
      };
      
      try { 
        const response = await updateUser(updateuser);   
        if(response.status === 200){  
          if(!isEmpty(nfcId) && nfcId!=null){
            if(user.nfc_tag){
              updateNfcId(user.nfc_tag.uid); 
            }else{
              addNfcId(response.data.data.id);
            } 
          }
          toast.success(response.data.message);   
        } else {
          toast.error(error.message); 
        }
      } catch (error) {
        toast.error(error.message); 
      }  
      validation.resetForm();
    } else {
      const newuser = {
        id: (Math.floor(Math.random() * (30 - 20)) + 20).toString(), 
        first_name: values.first_name,
        last_name: values.last_name,
        email: values.email,
        phone: values.phone,   
        street_address: values.street_address,
        seedpower_points: values.seedpower_points, 
        active: values.active
      };
      
      try { 
        const response = await addUser(newuser);  
        debugger 
        if(response.status === 200){  
          if(!isEmpty(nfcId) && nfcId!=null){ 
            addNfcId(response.data.data.id); 
          }
          toast.success(response.data.message);   
        } else {
          toast.error(response.message); 
        }
      } catch (error) {
        toast.error(error.message); 
      }  
      validation.resetForm();
    }
    toggle_modal();
  };

  const handleInfo = useCallback((arg) => {
    const user = arg;  
    setUser({ 
      id: user.id,
      first_name: user.first_name,
      last_name: user.last_name,
      email: user.email, 
      phone: user.phone,
      street_address: user.street_address, 
      seedpower_points: user.seedpower_points,
      parent_id: user.parents[0],
      nfc_tag: user.nfc_tag,
    });
    setNfcId(null);
    if(user.nfc_tag){
      setNfcId(user.nfc_tag.uid);
    }   
    setIsInfo(true);
    setIsEdit(true);
    toggle_modal();
  });
  // Update Data
  const handleuserClick = useCallback((arg) => {
    const user = arg;  
    setUser({
      id: user.id,
      first_name: user.first_name, 
      last_name: user.last_name,
      email: user.email,
      seedpower_points: user.seedpower_points,
      phone: user.phone, 
      street_address: user.street_address, 
      active: user.active,  
      nfc_tag: user.nfc_tag, 
    });
    setNfcId(null);
    if(user.nfc_tag){
      setNfcId(user.nfc_tag.uid);
    }   
    setIsInfo(false);
    setIsEdit(true);  
    toggle_modal();
  });
  const updateNfcId = async (old_uid) => {
    try { 
      const response = await userNfcUpdate(nfcId,old_uid);
       
      if(response.status === 200){
        toast.success(response.data.message); 
       setNfcId(response.data.data.uid); 
       toggle_modal();
       loadUserList(currentPage, pageSize);
       
      }
      else {
        errornotify(response.response.data.message);
      }
    }
    catch (error) {
      console.error('Error fetching NFC data:', error); 
    }
  }
const addNfcId = async (uid) => {
  try {
    const param={
      tag_type:"user",
      assigned_id:uid,
      uid:nfcId, 
    }
    const response = await nfcAdd(param);
    debugger
    if(response.status === 200){
      toast.success(response.data.message); 
     setNfcId(response.data.data.uid);
     toggle_modal();
     loadUserList(currentPage, pageSize);
    }
    else {
      errornotify(response.response.data.message);
    }
  }
  catch (error) {
    console.error('Error fetching NFC data:', error); 
  }
}



  // Checked All
  const checkedAll = useCallback(() => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".userCheckBox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
    deleteCheckbox();
  }, []);

  // Delete Multiple
  const [selectedCheckBoxDelete, setSelectedCheckBoxDelete] = useState([]);
  const [isMultiDeleteButton, setIsMultiDeleteButton] = useState(false);

  const deleteMultiple = async () => {
    const checkall = document.getElementById("checkBoxAll");
    for (const element of selectedCheckBoxDelete) {
      try {
        await deleteUser(element.value);
      } catch (error) {
        toast.error(error.message); 
      }
    }
    
    loadUserList(currentPage, pageSize);
    setIsMultiDeleteButton(false);
    checkall.checked = false;
    toast.success("Selected users deleted successfully");
  };

  const deleteCheckbox = () => {
    const ele = document.querySelectorAll(".userCheckBox:checked");
    ele.length > 0 ? setIsMultiDeleteButton(true) : setIsMultiDeleteButton(false);
    setSelectedCheckBoxDelete(ele);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        header: <input type="checkbox" className="form-check-input" id="checkBoxAll" onClick={() => checkedAll()} />,
        cell: (cell) => {
          return <input type="checkbox" className="userCheckBox form-check-input" value={cell.getValue()} onChange={() => deleteCheckbox()} />;
        },
        id: 'id',
        accessorKey: "id",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "First Name",
        accessorKey: "first_name",
        enableColumnFilter: false,
        cell: (cell) => (
            <>
            <div className="d-flex align-items-center"> 
                <Link to={"/employees-detail?userId="+cell.row.original.id} className="currency_name flex-grow-1 ms-2">{cell.getValue()}</Link>
            </div>
        </>
        ),
      },
      {
          header: "Last Name",
          accessorKey: "last_name",
          enableColumnFilter: false,
          
      },
      {
          header: "NFC ID",
          accessorKey: "nfc_tag.uid",
          enableColumnFilter: false, 
      }, 
      {
          header: "Email",
          accessorKey: "email",
          enableColumnFilter: false,
           
      },
      {
          header: "Seedpower Points",
          accessorKey: "seedpower_points",
          enableColumnFilter: false, 
      }, 
      {
          header: "Active",
          accessorKey: "active",
          enableColumnFilter: false,
         
      },  
      {
        header: "Action",
        cell: (cell) => {
          return (
            <ul className="list-inline hstack gap-2 mb-0"> 
              <li className="list-inline-item" title="View">
                <Link  className="edit-item-btn" to="#" onClick={() => { const userData = cell.row.original; handleInfo(userData); }} 
                >
                  <i className="ri-eye-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Edit">
                <Link className="edit-item-btn" to="#"
                  onClick={() => { const userData = cell.row.original; handleuserClick(userData); }}
                >
                  <i className="ri-pencil-fill align-bottom text-muted"></i>
                </Link>
              </li>
              <li className="list-inline-item" title="Delete">
                <Link
                  className="remove-item-btn"
                  onClick={() => { const userData = cell.row.original; onClickDelete(userData); }}
                  to="#"
                >
                  <i className="ri-delete-bin-fill align-bottom text-muted"></i>
                </Link>
              </li>
            </ul>
          );
        },
      },
    ],
    [handleuserClick, handleInfo, checkedAll]
  );
 
  // Export Modal
  const [isExportCSV, setIsExportCSV] = useState(false);

  document.title = "Employees | SeedNations";
  return (
    <React.Fragment>
      <div className="page-content">
        <ExportCSVModal
          show={isExportCSV}
          onCloseClick={() => setIsExportCSV(false)}
          data={userList}
        />

        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDeleteuser}
          onCloseClick={() => setDeleteModal(false)}
        />

        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid> 
          <BreadCrumb title="USER LIST" pageTitle="CRM" />

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center flex-wrap gap-2">
                    <div className="flex-grow-1">
                      <button className="btn btn-primary add-btn" onClick={() => { setIsEdit(false); setIsInfo(false); toggle_modal(); }}>
                        <i className="ri-add-fill me-1 align-bottom"></i> Add user
                      </button>
                    </div>
                    <div className="flex-shrink-0">
                      <div className="hstack text-nowrap gap-2">
                        {isMultiDeleteButton && <button className="btn btn-soft-danger"
                          onClick={() => setDeleteModalMulti(true)}
                        ><i className="ri-delete-bin-2-line"></i></button>}
                        <button className="btn btn-soft-primary">
                          <i className="ri-filter-2-line me-1 align-bottom"></i>{" "}
                          Filters
                        </button>
                        <button className="btn btn-soft-success" onClick={() => setIsExportCSV(true)}>Export</button>
                        <UncontrolledDropdown>
                          <DropdownToggle
                            href="#"
                            className="btn btn-soft-danger"
                            tag="button"
                            type="button"
                          >
                            <i className="ri-more-2-fill"></i>
                          </DropdownToggle>
                          <DropdownMenu className="dropdown-menu-end">
                            <DropdownItem className="dropdown-item" href="#">
                              All
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Week
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Month
                            </DropdownItem>
                            <DropdownItem className="dropdown-item" href="#">
                              Last Year
                            </DropdownItem>
                          </DropdownMenu>
                        </UncontrolledDropdown>
                      </div>
                    </div>
                  </div>
                </CardHeader>
              </Card>
            </Col>
            <Col xxl={12}>
              <Card id="userList">
                <CardBody className="pt-0">
                  <div>
                    {userList?.length ? (
                      <TableContainer
                        columns={columns}
                        data={(userList || [])}
                        total={total}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        onChange={handlePageChange}
                        isGlobalFilter={true}
                        isAddUserList={false}
                        customPageSize={10}
                        className="custom-header-css"
                        divClass="table-responsive table-card mb-2"
                        tableClass="align-middle table-nowrap"
                        theadClass="table-light"
                        handleuserClick={handleuserClick} 
                        isUserListFilter={true}
                        SearchPlaceholder='Search for user...'
                      />
                    ) : ""}
                  </div>
                  <Modal id="showModal" isOpen={modal} toggle={() => {
                    toggle_modal();
                }} centered size="lg">
                    <ModalHeader className="bg-info-subtle p-3" toggle={() => {
                    toggle_modal();
                }} >
                      {!!isInfo ? "User Info" : !!isEdit ? "Edit user" : "Add user"}
                    </ModalHeader>
                    <Form className="tablelist-form" onSubmit={(e) => {
                      e.preventDefault();
                      handleSubmit(validation.values);
                      return false;
                    }}>
                      <ModalBody>
                        <input type="hidden" id="id-field" />
                        <Row className="g-3">
                         
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="name-field"
                                className="form-label"
                              >
                                First Name
                              </Label>

                              <Input
                                name="first_name"
                                id="customername-field"
                                className="form-control"
                                placeholder="Enter user Name"
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                readOnly={isInfo}
                                disabled={isInfo}
                                onBlur={validation.handleBlur}
                                value={validation.values.first_name || ""}
                                invalid={
                                  validation.touched.first_name && validation.errors.first_name ? true : false
                                }
                              />
                              {validation.touched.first_name && validation.errors.first_name ? (
                                <FormFeedback type="invalid">{validation.errors.first_name}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="last_name-field"
                                className="form-label"
                              >
                                Last Name
                              </Label>
                              <Input
                                name="last_name"
                                id="last_name-field"
                                className="form-control"
                                placeholder="Enter last_name Name"
                                type="text"
                                validate={{
                                  required: { value: true },
                                }}
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.last_name || ""}
                                invalid={
                                  validation.touched.last_name && validation.errors.last_name ? true : false
                                }
                              />
                              {validation.touched.last_name && validation.errors.last_name ? (
                                <FormFeedback type="invalid">{validation.errors.last_name}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="country-field"
                                className="form-label"
                              >
                                NFC ID
                              </Label>
                              <Input
                                name="NFC_ID"
                                id="NFC-ID-field"
                                className="form-control"
                                placeholder="Enter NFC ID"
                                type="text"
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={(e) => {
                                  handleNFCIDChange(e.target.value);
                                }}
                                onBlur={validation.handleBlur}
                                value={nfcId || ""}
                                invalid={
                                  validation.touched.nfcId && validation.errors.nfcId? true : false
                                }
                              />
                              {validation.touched.nfcId && validation.errors.nfcId? (
                                <FormFeedback type="invalid">{validation.errors.nfcId}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="seedpower_points-field"
                                className="form-label"
                              >
                                SeedPower Points
                              </Label>
                              <Input
                                name="seedpower_points"
                                id="seedpower_point-field"
                                className="form-control"
                                placeholder="Enter seedpower_points"
                                type="text"
                                readOnly={isInfo}
                                disabled={isInfo}
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.seedpower_points || ""}
                                invalid={
                                  validation.touched.seedpower_points && validation.errors.seedpower_points ? true : false
                                }
                              />
                              {validation.touched.seedpower_points && validation.errors.seedpower_points ? (
                                <FormFeedback type="invalid">{validation.errors.seedpower_points}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="phone-field"
                                className="form-label"
                              >
                                phone
                              </Label>
                              <Input
                                name="phone"
                                id="phone-field"
                                className="form-control"
                                placeholder="Enter phone"
                                type="text" 
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.phone || ""}
                                invalid={
                                  validation.touched.phone && validation.errors.phone ? true : false
                                }
                              />
                              {validation.touched.phone && validation.errors.phone ? (
                                <FormFeedback type="invalid">{validation.errors.phone}</FormFeedback>
                              ) : null}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="email-field"
                                className="form-label"
                              >
                                 Email
                              </Label>
                              <Input
                                name="email"
                                id="email-field"
                                className="form-control"
                                placeholder="Enter Contact email"
                                type="text"
                                readOnly={isInfo}
                                disabled={isInfo}
                                validate={{
                                  required: { value: true },
                                }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email && validation.errors.email ? true : false
                                }
                              />
                              {validation.touched.email && validation.errors.email ? (
                                <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                              ) : null}
                            </div>
                          </Col> 
                             

                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="street_address-field"
                                className="form-label"
                              >
                                Street Address
                              </Label>
                              <Input
                                name="street_address"
                                id="street-adress-field"
                                className="form-control"
                                placeholder="Enter street address"
                                readOnly={isInfo}
                                disabled={isInfo}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.street_address || ""}
                                invalid={
                                  validation.touched.street_address && validation.errors.street_address
                                }
                              />
                              {validation.touched.street_address && validation.errors.street_address && (
                                <FormFeedback type="invalid">{validation.errors.street_address}</FormFeedback>
                              )}
                            </div>
                          </Col>
                          <Col lg={6}>
                            <div>
                              <Label
                                htmlFor="active-field"
                                className="form-label"
                              >
                                Active
                              </Label>  
                                  <Input className="form-control form-check-input" type="checkbox" role="switch"    
                                  name="active"   
                                  checked={validation.values.active || false}
                                  onChange={validation.handleChange}
                                  disabled={isInfo} id="active-field" defaultChecked/> 
                            </div>
                          </Col>
                        </Row>
                      </ModalBody>
                      <ModalFooter>
                          <div className="hstack gap-2 justify-content-end">
                            <Button color="light" onClick={() => { setModal(false); }}> Close </Button>
                            {!isInfo && (
                              <Button type="submit" color="success" id="add-btn"> 
                                {!!isEdit ? "Update" : "Add user"}
                              </Button>
                            )}
                          </div>
                      </ModalFooter>
                    </Form>
                  </Modal>
                </CardBody>
              </Card>
            </Col> 
          </Row> 
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Users;
